module.exports = __webpack_public_path__ + "static/media/step2img8.287836d9.JPG";